// Max file size for browser uploads (100 GB). Shared by Universe, Bulk, and Fast-ID upload forms.
// Files up to the S3 single-POST limit go through a presigned POST; larger files use multipart UploadPart.
export const MAX_UPLOAD_FILE_BYTES = 100 * 1024 * 1024 * 1024;

/** 1–40 for validate_universe / Fast-ID email_md5_column widget. */
export const UNIVERSE_COLUMN_OPTIONS = Array.from({ length: 40 }, (_, i) => String(i + 1));
